import { render, staticRenderFns } from "./TournamentMatches.vue?vue&type=template&id=3e46b5c4&scoped=true&"
import script from "./TournamentMatches.vue?vue&type=script&lang=js&"
export * from "./TournamentMatches.vue?vue&type=script&lang=js&"
import style0 from "./TournamentMatches.vue?vue&type=style&index=0&id=3e46b5c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e46b5c4",
  null
  
)

component.options.__file = "TournamentMatches.vue"
export default component.exports